<template>
  <div>
    <!--Stats cards-->
    <div class="row justify-content-center">
      <div v-for="stats in statsCards" class="col-lg-3 col-md-6 col-sm-6">
        <stats-card
          :type="stats.type"
          :icon="stats.icon"
          :small-title="stats.title"
          :title="stats.value"
        >
          <div slot="footer" class="stats">
            <i :class="stats.footerIcon" />
            <router-link :to="stats.route">{{ stats.footerText }}</router-link>
          </div>
        </stats-card>
      </div>
    </div>
    <overview-search-results-list :fetch-data="search" />
  </div>
</template>

<script>
import {
  isConnected,
  isOrganizationUser,
  isPowerUser,
  isAdministrator,
} from '@/services/AuthService';
import { StatsCard } from 'src/components/UIComponents';
import OverviewSearchResultsList from 'src/components/ApplicationViews/UIComponents/OverviewSearchResultsList';
import EventBus from 'src/event-bus';

export default {
  name: 'Overview',
  components: {
    EventBus,
    StatsCard,
    OverviewSearchResultsList,
  },
  data() {
    return {
      searchText: '',
      statsCards: [],
      searchResults: [],
    };
  },
  computed: {
    isConnected,
    isOrganizationUser,
    isPowerUser,
    isAdministrator,
    canConnectedUserAccessCustomLists() {
      return (
        this.isOrganizationUser || this.isPowerUser || this.isAdministrator
      );
    },
  },
  created() {
    this.fetchStats();
    // EventBus.$on('search', this.search);
  },
  beforeDestroy() {
    // EventBus.$off('search', this.search);
  },
  methods: {
    fetchStats() {
      this.$http
        .get(`${process.env.VUE_APP_ANNUAIRE_API_URL}/stats`)
        .then(response => {
          this.statsCards.push({
            type: 'warning',
            icon: 'nc-icon nc-single-02',
            title: 'Personnes',
            route: 'People',
            value: response.data.people.toString(),
            footerText: 'Gérer les personnes',
            footerIcon: '',
          });

          this.statsCards.push({
            type: 'success',
            icon: 'nc-icon nc-chat-33',
            title: 'Commissions',
            route: 'Committees',
            value: response.data.committees.toString(),
            footerText: 'Gérer les commissions',
            footerIcon: '',
          });

          this.statsCards.push({
            type: 'danger',
            icon: 'nc-icon nc-circle-10',
            title: 'Appartenances',
            value: response.data.memberships.toString(),
            route: '',
            footerText: '',
            footerIcon: '',
          });

          if (this.isConnected && this.canConnectedUserAccessCustomLists) {
            this.statsCards.push({
              type: 'info',
              icon: 'nc-icon nc-bullet-list-67',
              title: 'Listes',
              route: 'CustomLists',
              value: response.data.customLists.toString(),
              footerText: 'Gérer les listes',
              footerIcon: '',
            });
          }
        })
        .catch(error => {});
    },
    search(searchText) {
      let url = process.env.VUE_APP_ANNUAIRE_API_URL;
      if (searchText) {
        url += `/search/persons?searchTerm=${searchText}&page=0&size=100`;
      } else {
        url +=
          '/personEntities?projection=personPublicDTO&sort=lastName&sort=firName&sort=institutionName&page=0&size=100';
      }
      return this.$http
        .get(url)
        .then(response => ({
          searchResults: response.data._embedded.personEntities
            ? response.data._embedded.personEntities
            : [],
        }))
        .catch(error => {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
a {
  color: inherit;
}
.search-result {
  padding: 10px;
  margin-bottom: 10px;
  background-color: lightgrey;
}
</style>
